<template>
    <div class="transaction-info-container">
        Transaction:
        <a :href="`https://etherscan.io/tx/${transactionHash}`" target="_blank">
            {{ cTrimmedTransactionHash }}
        </a>
    </div>
</template>

<script>
export default {
    props: {
        transactionHash: { type: String, default: null }
    },
    computed: {
        cTrimmedTransactionHash() {
            console.log("🚀 ~ this.transactionHash", this.transactionHash);
            let transactionHash = "";
            if (this.transactionHash !== null) {
                const transactionFirstChunk = this.transactionHash.slice(0, 7);
                const transactionLastChunk = this.transactionHash.slice(-4);
                transactionHash = `${transactionFirstChunk}...${transactionLastChunk}`;
            }

            return transactionHash;
        }
    }
};
</script>

<style>
.transaction-info-container {
    color: white;
}
.transaction-info-container > a {
    color: rgb(255, 222, 73);
}
</style>
